<template>
  <div>
    <br />
    <vs-card style="border-radius: 20px">
      <vs-table max-items="5" pagination search hoverFlat="false" :data="alert">
        <template slot="header">
          <h3 class="ml-3">Alert</h3>
        </template>
        <template slot="thead" align="center">
          <vs-th></vs-th>
          <vs-th v-for="item in alerthead" :key="item">
            <div style="width: 100%; text-align: center">
              <vs-row>
                <span>{{ item }}</span>
                <span><vs-icon icon="unfold_more" size="13px"></vs-icon></span>
              </vs-row>
            </div>
          </vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td align="center">
              <vs-button
                icon="add_circle"
                type="flat"
                style="border-radius: 20px"
                >view</vs-button
              >
            </vs-td>
            <vs-td :data="data[indextr].Disarm_Button" align="center">
              <!-- {{ data[indextr].Disarm_Button }} -->
              <vs-button
                icon="notifications_active"
                color="warning"
                type="flat"
                 style="border-radius: 20px"
                :disabled="data[indextr].Disarm_Button == false"
                >Disarm</vs-button
              >
            </vs-td>
            <vs-td :data="data[indextr].Alert_id" align="center">
              {{ data[indextr].Alert_id }}
            </vs-td>
            <vs-td :data="data[indextr].Alert_Name" align="center">
              {{ data[indextr].Alert_Name }}
            </vs-td>
            <vs-td :data="data[indextr].Sensor_Name" align="center">
              <vs-icon
                icon="signal_cellular_alt"
                color="primary"
                size="20px"
                style="margin-top: -4px"
              />
              {{ data[indextr].Sensor_Name }}
            </vs-td>
            <vs-td :data="data[indextr].Message" align="center">
              {{ data[indextr].Message }}
            </vs-td>
            <vs-td :data="data[indextr].Status" align="center">
              <!-- {{ data[indextr].Status }} -->
              <vs-chip color="warning" v-if="data[indextr].Status === false"> Armed </vs-chip>
              <vs-chip color="primary" v-if="data[indextr].Status === true"> Disarmed </vs-chip>
            </vs-td>
            <vs-td :data="data[indextr].Alert_Timestamp" align="center">
              {{ data[indextr].Alert_Timestamp }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alerthead: [
        "Disarm Button",
        "Alert id",
        "Alert Name",
        "Sensor Name",
        "Message",
        "Status",
        "Alert Timestamp",
      ],
      alert: [
        {
          Disarm_Button: true,
          Alert_id: 1,
          Alert_Name: "Test",
          Sensor_Name: "Lora Sensor 1 ",
          Message: "Temperature Sensor_1 Greater Than 25",
          Status: false,
          Alert_Timestamp: "2021-12-01 17:15:14",
        },
         {
          Disarm_Button: false,
          Alert_id: 2,
          Alert_Name: "Test 2",
          Sensor_Name: "Lora Sensor 2 ",
          Message: "Temperature Sensor_2 Greater Than 25",
          Status: true,
          Alert_Timestamp: "2021-12-01 17:15:14",
        },
      ],
    };
  },
};
</script>

<style></style>
